// ============================================
// services/analyticsService.js
// ============================================
import { analyticsReady } from '../firebase';
import { reportError } from './errorReporting';

// Fire-and-forget logging; safe if Analytics isn't available
export async function trackEvent(name, params = {}) {
  try {
    const isBrowser = typeof window !== 'undefined';
    const isOffline = typeof navigator !== 'undefined' && navigator.onLine === false;
    const isCypress = isBrowser && !!window.Cypress;
    if (!isBrowser || isOffline || isCypress) return;

    const analytics = await analyticsReady;
    if (!analytics) return;
    const mod = await import('firebase/analytics');
    // Await in case logEvent is mocked as async in tests to avoid unhandled rejections
    await mod.logEvent(analytics, name, params);
  } catch (err) {
    // Swallow and report so tests/app don't crash under JSDOM/CI
    try { reportError(err, 'error', { where: 'analytics.trackEvent', name }); } catch (_) {}
  }
}

export const AnalyticsEvents = {
  PORCHLIGHT_TOGGLE: 'porchlight_toggle',
  INVITE_SENT: 'invite_sent',
  INVITE_ACCEPTED: 'invite_accepted',
  NOTIFICATION_OPT_IN: 'notification_opt_in',
};
